import Transform from '@ember-data/serializer/transform';
import {
  costValuesToView,
  viewToCostValues,
} from 'lumen/utils/net-revenue/cost/cost-values';
import type {
  CostValuesView,
  RawCostValue,
} from 'lumen/utils/net-revenue/cost/types';

/**
 * Deserializes the backend's flat `cost_values` array into the UI-stable
 * `CostValuesView`, and back. Thin wrapper over the pure mapper (mirrors
 * `net-revenue-money.ts`). Auto-discovered by EmberData as `@attr('cost-values')`.
 */
export default class CostValuesTransform extends Transform {
  deserialize(serialized: RawCostValue[] | null | undefined): CostValuesView {
    return costValuesToView(serialized ?? []);
  }

  serialize(deserialized: CostValuesView | null): RawCostValue[] {
    return deserialized ? viewToCostValues(deserialized) : [];
  }
}
